import React, { Fragment, ReactElement, ForwardedRef } from 'react';
import Tooltip from '../tooltip/tooltip.component';
import ActionButton from '../action-button/action-button.component';
import FormFieldText from '../form-field-text/form-field-text.component';
import SearchIcon from '../../icons/search-icon';
import FormatService from '../../services/format-service';
import useStylesSearchFieldBlock from './search-field-block.styles';

const SearchFieldBlock: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const PLACEHOLDER_SEARCH_TEXT_FIELD_DEFAULT: string = 'Search by people, companies, deals...';
  const PLACEHOLDER_SEARCH_TEXT_FIELD_SIMPLE: string = 'Search...';
  const TOOLTIP_TEXT_SEARCH: string = 'Search';

  const {
    isPlain,
    isFloat,
    isSimple,
    withNoButton,
    searchFieldName,
    onKeyDown,
    onKeyUp,
    onPointerDown,
    onSubmitForm,
  } = props;

  const { classes } = useStylesSearchFieldBlock();

  const buttonPlainClassName: string | undefined = isPlain ? classes.searchFieldBlockButtonPlain : undefined;
  const fieldClassName: string | undefined = isFloat ? classes.searchFieldBlockField : undefined;

  return (
    <Fragment>
      <FormFieldText
        withNoAutocomplete
        ref={ref}
        name={searchFieldName}
        className={FormatService.formatClassNames(classes.searchFieldBlockField, fieldClassName)}
        placeholder={isSimple ? PLACEHOLDER_SEARCH_TEXT_FIELD_SIMPLE : PLACEHOLDER_SEARCH_TEXT_FIELD_DEFAULT}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onPointerDown={onPointerDown}
      />
      {
        !withNoButton && (
          <div>
            <Tooltip title={TOOLTIP_TEXT_SEARCH}>
              <ActionButton
                className={FormatService.formatClassNames(classes.searchFieldBlockButton, buttonPlainClassName)}
                onClick={onSubmitForm}
              >
                <SearchIcon />
              </ActionButton>
            </Tooltip>
          </div>
        )
      }
    </Fragment>
  );
}));

export default SearchFieldBlock;
